import { LAYOUTS } from "../_Layouts.js";

export const BannerModeDevelopment = () => {
  if (LAYOUTS.TAG_MODE_DEVELOPMENT_BY !== true) return null;
  return null;
};
